import { BASE_URL } from "../api"
import { getStorefrontIdentifier, getStorefrontStatsApiBaseUrl } from "../../utils/storefront"

export const getStorefrontStats = async (store) => {
  const storeIdentifier = getStorefrontIdentifier(store)
  const rawStoreId = String(store?._id || store?.id || "").trim()

  if (!storeIdentifier) {
    return {
      totalVisits: 0,
      shortLinkVisits: 0,
      lastVisitedAt: null,
      storeId: "",
    }
  }

  const fallbackPayload = {
    totalVisits: 0,
    shortLinkVisits: 0,
    lastVisitedAt: null,
    storeId: storeIdentifier,
  }

  try {
    if (rawStoreId) {
      const backendResponse = await fetch(
        `${BASE_URL}/api/gestock/public/stores/${encodeURIComponent(rawStoreId)}/storefront-stats`
      )

      if (backendResponse.ok) {
        const backendPayload = await backendResponse.json()
        return backendPayload?.data || fallbackPayload
      }
    }
  } catch {
    // Fall back to the storefront service route while the main backend endpoint is unavailable.
  }

  try {
    const response = await fetch(
      `${getStorefrontStatsApiBaseUrl()}/api/storefront/stats/${encodeURIComponent(storeIdentifier)}`
    )

    if (!response.ok) {
      return null
    }

    const payload = await response.json()
    return payload?.data || fallbackPayload
  } catch {
    return null
  }
}
